export default __webpack_public_path__ + "static/B03-0c78f9d78fd01d36d17e055d8f36e54c.png";